export default __webpack_public_path__ + "static/media/person.5c62358f.png";